import { createElement, type ReactNode } from 'react';
import { PublicationModeContext, usePublicationMode, type PublicationMode } from './publication-mode';

export function PublicationModeProvider({
  children,
  mode,
}: {
  children: ReactNode;
  mode: PublicationMode;
}) {
  return (
    <PublicationModeContext.Provider value={mode}>
      {children}
    </PublicationModeContext.Provider>
  );
}

export function PublicationPage({ children, className }: { children: ReactNode; className: string }) {
  const mode = usePublicationMode();
  return createElement(mode === 'app' ? 'div' : 'main', { className }, children);
}
